var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscountNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9528 3.9759C11.1676 3.76109 11.4684 3.65557 11.7704 3.68912L16.8615 4.25481C17.3264 4.30646 17.6933 4.67341 17.745 5.13826L18.3107 10.2294C18.3442 10.5314 18.2387 10.8322 18.0239 11.047L10.5856 18.4853C10.195 18.8758 9.56187 18.8758 9.17135 18.4853L3.51449 12.8284C3.12397 12.4379 3.12397 11.8047 3.51449 11.4142L10.9528 3.9759Z",
    stroke: "#0E5CF4",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.8281,
    cy: 8.17203,
    r: 1,
    transform: "rotate(45 13.8281 8.17203)",
    fill: "#0E5CF4",
    stroke: "#0E5CF4",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountNew);
export default __webpack_public_path__ + "static/media/discount-new.8b28fdd571f313d1dbb658b4141a00d1.svg";
export { ForwardRef as ReactComponent };